import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: null,
		tokenExpire: null,
		tagsStoreList: [],
		language: Cookies.get('language') || 'en',
		DepartmentName: '',
		activeSchoolId: window.localStorage.getItem('activeSchoolId') || null, // 全局活跃学校ID
		activeSchoolName: window.localStorage.getItem('activeSchoolName') || '', // 全局活跃学校名称
		sysLayoutMode: window.localStorage.getItem('sysLayoutMode') || 'classic', // 全局布局模式：classic(经典), portal(应用门户)
		myShortcutIds: JSON.parse(window.localStorage.getItem('my_shortcuts') || '[]'), // 全局置顶常用快捷菜单ID数组
		portalDeptGroups: [], // 大桌面门户分类配置 (含各处室关联的菜单 ID 列表)，用于侧边栏权限过滤
	},
	mutations: {
		saveToken(state, data) {
			state.token = data
			window.localStorage.setItem('Token', data)
		},
		saveTokenExpire(state, data) {
			// 统一存 ISO，避免 Date.toString() 在中文环境下 Date.parse 不稳定。最后修改：2026-09-22
			let value = data
			if (data instanceof Date) {
				value = isNaN(data.getTime()) ? '' : data.toISOString()
			} else if (data && typeof data === 'string') {
				const parsed = new Date(Date.parse(data))
				value = isNaN(parsed.getTime()) ? data : parsed.toISOString()
			}
			state.tokenExpire = value
			window.localStorage.setItem('TokenExpire', value || '')
		},
		saveTagsData(state, data) {
			state.tagsStoreList = data
			sessionStorage.setItem('Tags', data)
		},
		SET_LANGUAGE: (state, language) => {
			state.language = language
			Cookies.set('language', language)
		},

		setDepartmentName(state, data) {
			if (data) {
				window.localStorage.setItem('DepartmentName', data)
				state.DepartmentName = data
			}
		},

		setActiveSchool(state, data) {
			if (data && data.schoolId) {
				state.activeSchoolId = data.schoolId
				state.activeSchoolName = data.schoolName
				window.localStorage.setItem('activeSchoolId', data.schoolId)
				window.localStorage.setItem('activeSchoolName', data.schoolName)
			} else {
				state.activeSchoolId = null
				state.activeSchoolName = ''
				window.localStorage.removeItem('activeSchoolId')
				window.localStorage.removeItem('activeSchoolName')
			}
		},

		saveLayoutMode(state, data) {
			state.sysLayoutMode = data
			window.localStorage.setItem('sysLayoutMode', data)
		},

		saveShortcutIds(state, data) {
			state.myShortcutIds = data
			window.localStorage.setItem('my_shortcuts', JSON.stringify(data))
		},

		// 保存大桌面门户分类配置 (含各处室关联的菜单 ID 列表，用于侧边栏权限过滤)
		savePortalDeptGroups(state, data) {
			state.portalDeptGroups = data
			try {
				window.localStorage.setItem('global_dept_groups', JSON.stringify(data || []))
			} catch (e) { /* ignore quota */ }
		},
	},
	actions: {
		setLanguage({ commit }, language) {
			commit('SET_LANGUAGE', language)
		},
	},
})
